const CLICK = "sure-quote/Login/CLICK";
const CHANGEAVATAR = "sure-quote/Login/CHANGEAVATAR";
const CLEAR = "sure-quote/Login/CLEAR";

const defaultState = {
  userEmail: "",
  name: "",
  surname: "",
  userID: "",
  token: "",
  avatar: "",
  userType:""
};

const handleChangeAvatar = (state, action) => {
  var uAvatar = action.props.props;
  return {
    ...state,
    avatar: uAvatar
  };
};

const handleClick = (state, action) => {
  let obj = {};

  if (action.props.props.token) {
    obj = {
      userEmail: action.props.props.userName,
      userID: action.props.props.id,
      token: action.props.props.token,
      name: action.props.props.name,
      surname: action.props.props.surname,
      avatar: action.props.props.avatar,
      userType: action.props.props.userType
    };
  }

  return {
    ...state,
    ...obj
  };
};

const handleClear = (state, action) =>{

    let obj = {
      userEmail: "",
      userID: "",
      token: "",
      name: "",
      surname: "",
      avatar: "",
      userType: ""
    };

  return {
    ...state,
    ...obj
  };
}

const LoginReducer = (state = defaultState, action) => {
  switch (action.type) {
    case CLICK:
      return handleClick(state, action);
    case CHANGEAVATAR:
      return handleChangeAvatar(state, action);
    case CLEAR:
      return handleClear(state, action);
    default:
      return state;
  }
};

export const Click = props => ({ type: CLICK, props });
export const changeAvatar = props => ({ type: CHANGEAVATAR, props });
export const Clear = props => ({ type: CLEAR, props });

export default LoginReducer;



// WEBPACK FOOTER //
// ./src/reducers/LoginReducer.js